import React, { useEffect, useState, useRef } from "react";
import Button from "components/button/button";
import Input from "components/input/input";
import InputType from "components/input/input-type";
import Select from "components/select/select";
import { FaMinus, FaPlus, FaPaperclip } from "react-icons/fa";
import { RxDragHandleDots2 } from "react-icons/rx";
import FileUpload from "components/file-upload/file-upload";
import DropzoneUpload from "components/file-upload/dropzone-upload";
import ImagePreviewWithLoader from "components/file-upload/image-preview-with-loader";
import Popup from "reactjs-popup";
import AddButtonListItem from "../profile/milestones/more-option/add-button-list-item";
import { Container, Draggable } from "@edorivai/react-smooth-dnd";

import LinkIconSVG from "assets/svg/link-icon";
import VideoEmbedIconSVG from "assets/svg/video-embed-icon";
import VideoFileIconSVG from "assets/svg/video-file-icon";
import AudioIconSVG from "assets/svg/audio-icon";
import ImageIconSVG from "assets/svg/image-icon";
import TextIconSVG from "assets/svg/text-icon";
import Favicon from "components/fav-icon/Favicon";
import { useTranslation } from "react-i18next";
import { useMilestones } from "redux/modules/milestone/hooks";
import UpgradePremium from "components/subscription/upgrade-premium";
import PopInfo from "components/info-popup/pop-info";
import { useWindowDimensions } from "utils/customhooks";
import { BsExclamationDiamondFill } from "react-icons/bs";

let ORIENTATION = [
  {
    id: 1,
    label: "Landscape",
    value: "Landscape",
  },
  {
    id: 2,
    label: "Portrait",
    value: "Portrait",
  },
  {
    id: 3,
    label: "Square",
    value: "Square",
  },
];

const noop = () => {};

export default function LinkGroupSelect({
  linkType = [],
  setItems = noop,
  userData = {},
  label = "",
  labelClass = "text-sm font-bold text-darkerGray",
  onAdd = noop,
  onUpload = noop,
  onUploadMultiple = noop,
  onPreUpload = noop,
  onRemove = noop,
  onSelect = noop,
  onChange = noop,
  onBlur = noop,
  onSelectSubType = noop,
  optional = false,
  errors = {},
  onRemoveMedia = noop,
  onChangeLabel = noop,
  isSubscribed = true,
  facebookOrient = noop,
  hide,
  currentButtonCount,
  showPopInfo = false,
  popInfoType = "",
  showMediaHandle = ()=>{},
}) {
  const {t} = useTranslation();
  const optionRef = useRef();
  const [showMoreOption, setShowMoreOption] = useState(false);
  const [progress, setProgress] = useState([]);
  const {isMobile} = useWindowDimensions();

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    // Update the order attribute
    result.forEach((item, index) => {
      item.order = index;
    });
    return result;
  };

  const onDrop = (dropResult) => {
    const { removedIndex, addedIndex } = dropResult;

    const reorderedItems = reorder(linkType, removedIndex, addedIndex);
    setItems(reorderedItems);
  };

  const isUploading = () => {
    return Object.values(progress).some((p) => p < 100 && p !== undefined);
  }

  useEffect(() => {
    window.addEventListener(
      "scroll",
      () => {
        if (optionRef.current) {
          optionRef.current.close();
        }
      },
      true
    );
  }, []);

  const IsFacebookOrTwitter = ({ subType, value, index, obj }) => {
    if (
      subType === "Video Embed" ||
      subType === "Embed" ||
      subType === "Youtube/Vimeo Link"
    ) {
      if (
        value.includes("www.facebook.com") ||
        value.includes("twitter.com") ||
        value.includes("x.com")
      ) {
        return (
          <Select
            // label="Orientation"
            options={ORIENTATION}
            placeholder="Orientation"
            name="orientation"
            value={
              obj?.orientation
                ? ORIENTATION.filter((m) => m.value === obj?.orientation)[0]
                : ""
            }
            height={58}
            formContainer="w-[8vw] flex-1 4sm:max-w-[7.8rem] min-w-[7.8rem] flex-shrink-0"
            onChange={(e) => facebookOrient(e, index)}
            // errorMessage={errorMessages?.privacy}
            labelClass="text-sm font-bold text-darkerGray leading-4 marked"
          />
        );
      }
    }
    return <></>;
  };

  const minusIconButton = (index) => (
    <button
      className="h-6.5 w-6.5 bg-lightBlack rounded-full"
      onClick={() => onRemove(index)}
    >
      <FaMinus className="m-auto text-white" />
    </button>
  );

  return (
    <div className="w-full mb-6">
      {label && (
        <label className={`${labelClass} leading-4 flex flex-row gap-x-2 items-center`}>
          {label}
          {optional && <span className="font-normal">{" (optional)"}</span>}
          {showPopInfo && 
            <div className="text-black font-normal">
              <PopInfo type={popInfoType} showMediaHandle={showMediaHandle} borderColor="border-darkerGray" responsive = {isMobile ? {right: "10px", arrow_right:"24px"} : null} direction={isMobile ? 'right' : 'left'} topCss="-8.5rem"/>
            </div>}
        </label>
      )}
      <div className={`w-full`}>
        <Container
          groupName="1"
          dropPlaceholder={false}
          getGhostParent={() => document.querySelector(".smooth-dnd-parent")}
          shouldAnimateDrop={() => false}
          dragClass="tilt"
          getChildPayload={(i) => linkType[i]}
          dragHandleSelector=".dragHandleSelector"
          onDrop={onDrop}
        >
          {linkType.map((obj, index) => {
            const { subType = {} } = obj;
            let isMedia = subType.is_media_file ? true : false;
            let isMultiple = subType.multiple ? true : false;
            let accept = subType.accept ? subType.accept : null;
            let isAudio = false;

            const isFirstAudioFile = 
              obj.subType === "Audio File" &&
              linkType.findIndex(item => item.subType === "Audio File") === index;

            const previews = obj.value ? obj.value : obj.media;

            let inputIcon = null;
            if (obj.subType === "Link") {/**obj?.fav_icon from library */
              inputIcon = obj?.value ? (
                <Favicon domain={obj.value} hasFavIconFile={obj?.fav_icon || null}/>
              ) : (
                <LinkIconSVG className="text-lg" />
              );
            } else if (
              obj.subType === "Video Embed" ||
              obj.subType === "Embed"
            ) {
              inputIcon = obj?.value ? (/**obj?.fav_icon from library */
                <Favicon domain={obj.value} hasFavIconFile={obj?.fav_icon || null}/>
              ) : (
                <VideoEmbedIconSVG className="text-lg" />
              );
            } else if (obj.subType === "Audio File") {
              inputIcon = <AudioIconSVG className="text-lg" />;
              accept = ".mp3,.wav,.ogg,.m4a,.flac,.aac,.opus,.m4b";
              isMedia = true;
              isMultiple = false;
              isAudio=true
            } else if (
              obj.subType === "Multiple Images" ||
              obj.subType === "Single Image"
            ) {
              inputIcon = <ImageIconSVG className="text-lg" />;
              accept = "image/*";
              isMedia = true;
              isMultiple = true;
            } else if (obj.subType === "Upload") {
              if (obj?.label === "Watch") {
                inputIcon = <VideoFileIconSVG className="text-lg" />;
                accept = "videos/*";
              } else {
                inputIcon = <TextIconSVG className="text-lg" />;
                accept = ".pdf";
              }

              isMedia = true;
              isMultiple = false;
            }

            return (
              <Draggable key={index} className="py-2 box-border">
                <div>
                   {
                      isFirstAudioFile &&
                      <div className="text-xs text-center text-[#fabf1f] mb-2">
                        <div className="inline-flex items-start justify-center gap-1.5">
                          <BsExclamationDiamondFill className="mt-0.5 flex-shrink-0" />
                          <span className="text-balance">
                            Do not upload any audio that is not legally yours. If you do not own the rights, instead put a link to a YouTube video, or link to a site where the audio can be streamed or bought.
                          </span>
                        </div>
                      </div>
                    }
                  <div
                    className={[
                      "grid grid-cols-[1rem_auto_1.5625rem] gap-2 grid-rows-[auto_auto]", 
                      isMultiple
                        ? "[&_.bg-siteBg]:col-span-1 4sm:[&_.bg-siteBg]:col-span-2"
                        : `grid-rows-2`,
                      `4sm:grid-cols-[1.5rem_1fr_1fr_1.5625rem] 4sm:grid-rows-1 4sm:gap-x-3`,
                    ].join(" ")}
                  >
                    <span
                      className={`draggable-item dragHandleSelector ml-[-0.35rem] ${
                        isMultiple ? "mt-6" : "mt-4"
                      }`}
                    >
                      <RxDragHandleDots2 className="text-2xl color-gray dnd-handle" />
                    </span> 
                    <div
                      className={`w-full gap-x-4 gap-y-2 ${
                        isMultiple
                          ? "flex flex-col p-3 bg-siteBg rounded col-span-2"
                          : ""
                      }`}
                    >
                      <InputType
                        inputContainerClass="flex-1"
                        value={obj?.label}
                        name="label"
                        placeholder="Button Label"
                        outsideLabelClass="text-sm font-bold text-darkerGray"
                        noLabelPaddingY="1rem"
                        inputIcon={inputIcon}
                        iconPosition="left"
                        type="text"
                        onChange={(value) => onChangeLabel(value, index)}
                        errorMessagePosition="bottom"
                        maxLength={45}
                      />

                      {isMedia && isMultiple && ( 
                        <DropzoneUpload
                          userData={userData}
                          onPreUpload={onPreUpload}
                          linkType={linkType}
                          itemIndex={index}
                          setProgress={setProgress}
                          setItems={setItems}
                          onUploadMultiple={(e) => onUploadMultiple(e, index)}
                        />
                      )}

                      {Array.isArray(previews) && (
                        <div className="mt-2">
                          <ImagePreviewWithLoader
                            progress={progress}
                            setProgress={setProgress}
                            images={previews}
                            linkType={linkType}
                            linkTypeIndex={index}
                            setLinkType={setItems}
                            onRemove={(e) => onRemoveMedia(e, index)}
                          />
                        </div>
                      )}

                      {/* <div className="flex space-x-3 items-center"> */}

                      {/* {errors[`media.${index}.value`] && (
                        <p className="input-error-message mt-2 -mb-1">
                          * {errors[`media.${index}.value`]}
                        </p>
                      )} */}

                      {/* button remove */}
                      {/* {!isMultiple && (
                      <div className="flex items-center">
                        {minusIconButton(index)}
                      </div>
                    )} */}
                    </div>
                    {/* {isMultiple && ( */}
                    <div
                      className={
                        "flex items-start " + (isMultiple ? "mt-6" : "mt-4")
                      }
                    >
                      {minusIconButton(index)}
                      {/* {isMultiple ? "true" : "false"} */}
                    </div>

                    {!isMedia && (
                      <div
                        className={[
                          `lineConnector flex gap-2 col-start-2 row-start-2 col-span-2 relative pl-[1.3rem] flex-wrap 4sm:flex-nowrap`,
                          `4sm:col-start-3 4sm:row-start-1 4sm:col-span-1 4sm:pl-0`,
                          `[&>div>div>div]:mt-0`
                        ].join(" ")}
                      >

                        <Input
                          inputContainerClass="flex-1 flex-shrink-0 min-w-[10rem]"
                          name={`link-${index}`}
                          value={obj.value}
                          placeholder="https://www.link.com/image1"
                          noLabelPaddingY="1rem"
                          type="text"
                          onChange={(e) => onChange(e, index)}
                          onBlur={() => onBlur(index)}
                          errorMessage={
                            errors[`media.${obj.value}.value`] ||
                            (errors?.media && errors?.media[index])
                          }
                        />
                        
                        <IsFacebookOrTwitter
                          obj={obj}
                          subType={obj.subType}
                          value={obj.value}
                          index={index}
                        />
                      </div>
                    )}

                    {isMedia && !isMultiple && (
                      <div
                        className={[
                          `lineConnector flex gap-2 col-start-2 row-start-2 col-span-2 relative pl-[1.3rem]`,
                          `4sm:col-start-3 4sm:row-start-1 4sm:col-span-1 4sm:pl-0`,
                        ].join(" ")}
                      >
                        <div className={`w-full [&_.w-full.relative.mt-2]:mt-0 overflow-hidden`}>
                          <FileUpload
                            image_name={obj.placeholder || ``}
                            fileObject={obj}
                            id={`singe-file-${index}`}
                            formContainer="flex-1 relative h-full"
                            showPreview={false}
                            accept={accept || ".pdf,image/*,audio/*"}
                            className="absolute top-1.5 right-2 bg-modalGray py-3.5 px-4 rounded-md text-lightBlack"
                            icon={<FaPaperclip className="text-lg" />}
                            onUpload={(e) => onUpload(e, index)}
                            errorMessage={errors[`media.${index}.value`]}
                            isAudio={isAudio}
                            userData={userData}
                            itemIndex={index}
                            setItems={setItems}
                          />
                        </div>
                      </div>
                    )}

                    {/* )} */}
                  </div>
                </div>
              </Draggable>
            );
          })}
        </Container>

        <div className="flex flex-row items-center justify-start">
          <Popup
            ref={optionRef}
            position="top left"
            open={showMoreOption}
            onClose={() => setShowMoreOption(false)}
            arrow={false}
            contentStyle={{
              marginTop: -8,
              marginLeft: 5,
              borderRadius: "6px",
              border: "2px solid #dddddd",
              zIndex: 9999,
            }}
            trigger={
              <div
                className={`w-full 4sm:w-auto [&>button]:w-full [&>button]:flex 
                    [&>button]:flex-row [&>button]:items-center [&>button]:justify-center 
                    [&>button]:4sm:w-auto [&>button]:4sm:inline-block ${!isSubscribed && currentButtonCount >= 10 ? "hidden" : ""}`}
              >
                <Button
                  buttonName={`${t('addButton')}`}
                  //buttonName={`Add ${
                  //linkType.length > 0 ? "Another " : ""
                  //}Button`}
                  buttonTextClass="text-sm text-white font-semibold flex items-center"
                  iconPosition="left"
                  icon={<FaPlus className="mr-3" />}
                  buttonRadius="6px"
                  buttonClass="relative py-4 px-9 bg-lightBlack"
                  onClick={() => setShowMoreOption((open) => !open)}
                />
                {
                  !isSubscribed && <span className="text-xs text-darkerGray ml-2 relative -bottom-4">{`${10-currentButtonCount} button${10-currentButtonCount===1?"":"s"} left on your free account`}</span>
                }
              </div>
            }
          >
            <AddButtonListItem
              {...{
                hide: () => {},
              }}
              closeMoreOption={(selectedType) => {
                onAdd(selectedType);
                setShowMoreOption(false);
                optionRef.current.close();
              }}
            />
          </Popup>
        </div>
      </div>
      {
        !isSubscribed && currentButtonCount >= 10 && (
          <div className="mt-4">
            <UpgradePremium
              styleProp="list"
              onClick={() => hide("upgrade")}
              customHeadline={"Unlock Unlimited Buttons"}
              customText="All free buttons used. Unlock unlimited with Premium."
            />
          </div>
        )
      }

    </div>
  );
}
